<template>
<div class="flex flex-row overflow-auto w-full">
    <TheSideNavigationBar />
    <div class="flex-auto flex-grow flex-shrink bg-background-50" id="mainContent">
      <TheContentTopNavigationBar />
      <div class="w-full px-8">
        <ListMenuBar
          search-placeholder-label="Search user by category name"
          @search="(val) => search(val)"
          @search-reset="() => reset()"
          @filter-changed="(val) => filterChanged(val)"
          style-dropdown-content="min-width:210px"
          :filter="true"
          :filter-data="filter"
          main-context-button-label="Add Category"
          :main-context-button-target="{
            name: 'route.dashboard.category.editor.create'
          }"
          use-main-context-button
        ></ListMenuBar>
        <div class="px-12 py-12 my-8 bg-white rounded">
          <ListTableSimple @row-selected="showDetail" :ready="CATEGORY_READY" :items="GET_CATEGORIES" :columns="columns"></ListTableSimple>
          <!-- <hr class="border-gray-300  mt-3"> -->
        <SimplePagination v-show="CATEGORY_READY" :min="1" :max="GET_CATEGORY_TOTAL_PAGE" :page="fetchParam.currentPage" @move="(step) => movePage(step)" />
        </div>
      </div>
    </div>
    <TheSideCalendarBar :range="range" hide-today @date-updated="(val) => dateRangeUpdated(val)" />
  </div>
</template>

<script>
import ListMenuBar from '@/components/List/ListMenuBar.vue'
import ListTableSimple from '@/components/List/ListTableSimple.vue'
import TheSideCalendarBar from '@/components/TheSideCalendarBar.vue'
import TheSideNavigationBar from '@/components/TheSideNavigationBar.vue'
import TheContentTopNavigationBar from '@/components/TheContentTopNavigationBar.vue'
import SimplePagination from '@/components/Paginate/SimplePagination.vue'
import { createNamespacedHelpers } from 'vuex'

const category = createNamespacedHelpers('category')

export default {
  components: {
    ListMenuBar: ListMenuBar,
    ListTableSimple: ListTableSimple,
    TheSideNavigationBar,
    TheSideCalendarBar,
    TheContentTopNavigationBar,
    SimplePagination
  },
  computed: {
    ...category.mapGetters(['GET_CATEGORIES', 'CATEGORY_READY', 'GET_CATEGORY_TOTAL_PAGE'])
  },
  data () {
    return {
      columns: [
        {
          label: 'Category name',
          name: 'article_category_name'
          // hasEmbeddedImage: true
        },
        // {
        //   label: 'Name',
        //   name: 'fullname'
        // },
        // {
        //   label: 'Role',
        //   name: 'role'
        // },
        {
          label: 'Create Date',
          name: 'created_at',
          isDate: true
        }
      ],
      items: [],
      range: {
        start: '',
        end: ''
      },
      fetchParam: {
        filter: {
          target: 'created_at',
          sort: 'asc'
        },
        currentPage: 1,
        range: {
          start: '',
          end: ''
        }
      },
      filter: [
        { label: 'Create date', target: 'created_at', sort: 'asc', checked: true },
        { label: 'Create date', target: 'created_at', sort: 'desc', checked: false },
        { label: 'Title', target: 'article_category_name', sort: 'asc', checked: false },
        { label: 'Title', target: 'article_category_name', sort: 'desc', checked: false }
      ]
    }
  },
  mounted () {
    // var token = localStorage.getItem('access_token')
    // if (token === null) {
    //   this.$router.push({ name: 'route.root' })
    // } else {
    //   console.log(token)
    // }
  },
  created () {
    this.range.start = this.moment().startOf('month').format('YYYY-MM-DD')
    this.range.end = this.moment().endOf('month').format('YYYY-MM-DD')
    this.fetchParam.start = this.range.start
    this.fetchParam.end = this.range.end
    this.reset()
  },
  methods: {
    ...category.mapActions(['getCategories', 'findCategories']),
    movePage (step) {
      this.fetchParam.currentPage += step
      // console.log(this.fetchParam.currentPage)
      this.reset()
    },
    dateRangeUpdated (val) {
      this.fetchParam.range.start = this.moment(val.start).format('YYYY-MM-DD')
      this.fetchParam.range.end = this.moment(val.end).format('YYYY-MM-DD')
      this.reset()
    },
    filterChanged (val) {
      this.fetchParam.filter = val
      this.reset()
    },
    showDetail (index) {
      this.$router.push({ name: 'route.dashboard.category.editor.detail', params: { id: this.GET_CATEGORIES[index].id } })
    },
    search (val) {
      var data = { find: val }
      this.findCategories({ data: data })
    },
    reset () {
      this.getCategories({ data: { range: this.fetchParam.range, page: this.fetchParam.currentPage, filter: this.fetchParam.filter } })
        .catch((err) => {
          if (err.response.status !== undefined && err.response.status === 401) {
            localStorage.removeItem('access_token')
            this.$router.push({ name: 'route.root' })
          } else if (err.response !== undefined && err.response.status === 403) {
            this.$router.push({ name: 'route.dashboard.home' })
          }
        })
    }
  }
}
</script>
